export default {
  title: 'Contract Management',
  message: {
    kycRequired: 'Please complete KYC verification before signing the IB agreement',
  },
  table: {
    columns: {
      header: {
        uuid: 'ID',
        title: 'Contract & Agreement Name',
        type_text: 'Type',
        status: 'Status',
        created_at: 'Time',
        signed_region: 'Signed IP (Region)',
        signed_device: 'Signed Device',
        action: 'Action',
      },
      button: {
        sign: 'Sign',
        view: 'View',
      },
      status: {
        1: 'Pending',
        2: 'Signed',
      },
    },
  },
  ib: {
    button: {
      sign: 'Confirm Signature',
    },
    sign: {
      title: 'Signature',
      signLabel: 'Signature',
      eSignConsentStatement:
        'I confirm that I have carefully read all the terms and conditions of the Risk Acknowledgement And Disclosure, and that the information I have provided is true and accurate. I agree to sign this electronic agreement, which is legally binding, and I understand that this electronic signature is equivalent to a handwritten signature.',
    },
  },
}
